<template>
   <div>
      <h6>What is your {{ fuelName }} usage?</h6>

      <label for="usage">{{ `${capitalizeFirstLetter(fuelName)} Consumption` }}</label>

      <validation-messages :label="`${capitalizeFirstLetter(fuelName)} Consumption`" :$v="$v.form.usage">
         <label for="usage" class="sr-only">Usage</label>
         <div class="input-group right">
            <form-field id="usage" type="number" v-model="form.usage" :error="$v.form.usage.$error"
               @change="$v.form.usage.$touch()" />
            <div class="input-group-addon">kWh/year</div>
         </div>
      </validation-messages>

      <div class="sticky-footer">
         <div class="col-xs-5">
            <uiv-btn type="link" block @click="goToQuestion('home'); resetForm()">Back</uiv-btn>
         </div>
         <div class="col-xs-7">
            <uiv-btn type="primary" block @click="onSave">Save</uiv-btn>
         </div>
      </div>
   </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { numeric, minValue, maxValue } from 'vuelidate/lib/validators';

export default {
   name: 'Usage',
   data() {
      return {
         form: {
            usage: null
         },
         electricityUsageConditions: { min: 1, max: 75000 },
         gasUsageConditions: { min: 1, max: 200000 }
      };
   },
   validations() {
      return {
         form: {
            usage: {
               numeric,
               minValue: minValue(this.usageValidation().min),
               maxValue: maxValue(this.usageValidation().max)
            }
         }
      }
   },
   computed: {
      ...mapState({
         quote: ({ quote }) => quote,
         fuelName: ({ quote }) => {
            if (quote.compareFuel == 'gasElectricity') {
               if (quote.editMode.prop == 'gasCurrentUsageEstimated') {
                  return 'gas';
               }

               if (quote.editMode.prop == 'electricityCurrentUsageEstimated') {
                  return 'electricity';
               }
            } else {
               if (quote.compareFuel == 'gas') {
                  return 'gas';
               }

               if (quote.compareFuel == 'electricity') {
                  return 'electricity';
               }
            }
         }
      })
   },
   methods: {
      ...mapActions({
         goToQuestion: 'quote_questions/goToQuestion'
      }),
      usageValidation() {
         const { editMode } = this.quote;
         if (this.quote.compareFuel == 'gasElectricity') {
            if (editMode.prop == 'gasCurrentUsageEstimated') {
               return this.gasUsageConditions;
            }

            if (editMode.prop == 'electricityCurrentUsageEstimated') {
               return this.electricityUsageConditions;
            }
         } else {
            if (this.quote.compareFuel == 'gas') {
               return this.gasUsageConditions;
            }

            if (this.quote.compareFuel == 'electricity') {
               return this.electricityUsageConditions;
            }
         }

         return this.gasUsageConditions;
      },
      capitalizeFirstLetter(string) {
         if (!string) return '';
         return string.charAt(0).toUpperCase() + string.slice(1);
      },
      resetForm() {
         this.form.usage = null;
         this.$v.form.$reset();
      },
      onSave() {
         if (this.$v.form.usage.$invalid) return;

         this.quote[this.quote.editMode.prop] = this.form.usage;

         this.goToQuestion('home');
         this.resetForm();
      }
   }
};
</script>

<style lang="scss"></style>
